
export default {
    props: {
        links: {
            type: Array,
            defualt: () => {}
        }
    },
}
